import { translate } from 'i18n';
import { useNavigate } from 'react-router-dom';
import { Button, Menu, MenuItem, Stack } from 'ui';
import { ArrowDropDown } from 'ui/icons';

export const ManageDataButton = () => {
  const navigate = useNavigate();
  const options = [
    {
      label: translate('backlog.manageDataButton.options.aiBalePhotos', { namespace: 'features' }),
      onClick: () => navigate('ai-bale'),
    },
    {
      label: translate('backlog.manageDataButton.options.marketingMedia', { namespace: 'features' }),
      onClick: () => navigate('marketing'),
    },
    {
      label: translate('backlog.manageDataButton.options.loadingEvidence', { namespace: 'features' }),
      onClick: () => navigate('loading'),
    },
    {
      label: translate('backlog.manageDataButton.options.siteEvidence', { namespace: 'features' }),
      onClick: () => navigate('site'),
    },
    {
      label: translate('backlog.manageDataButton.options.samples', { namespace: 'features' }),
      onClick: () => navigate('sample'),
    },
    {
      disabled: true,
      label: translate('backlog.manageDataButton.options.specifications', { namespace: 'features' }),
      onClick: () => navigate(''),
    },
  ];

  return (
    <Stack
      direction="row"
      sx={{
        width: '100%',
        gap: 2,
      }}
    >
      <Menu
        button={
          <Button fullWidth endIcon={<ArrowDropDown />}>
            {translate('backlog.manageDataButton.buttonLabel', { namespace: 'features' })}
          </Button>
        }
      >
        {options.map((option) => (
          <MenuItem key={option.label} onClick={option.onClick} disabled={option.disabled}>
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </Stack>
  );
};
